export const OChainId = {
  unsupported: 0,
  ethereum: 1,
  holesky: 17000,
  mantle: 5000,
  mantleSepolia: 5003,
  okxXLayer: 196,
  okxXLayerTestnet: 195,
  manta: 169,
  scroll: 534351,
  lineaSepolia: 59141,
  linea: 59140,
  zircuit: 48899,
  binanceSmartChain: 56,
  binanceSmartChainTestnet: 97,
  sepolia: 11155111,
  base: 8453,
  baseSepoliaTestnet: 84532,
  berachain: 80094,
  berachainBartioTestnet: 80084,
  corn: 21000000,
  bob: 60808,
  swell: 1923,
  morph: 2818,
  morphHolesky: 2810,
  sonic: 146,
} as const;

export type TChainId = (typeof OChainId)[keyof typeof OChainId];

export const isKnownChain = (chainId: number): chainId is TChainId =>
  Object.values(OChainId).includes(chainId as TChainId);
